import type React from 'react';

import { Box } from '@mui/material';

import { nodeIcons } from '../icons';

import type { NodeIconName } from '../icons';

interface NodeIconProps {
  name: NodeIconName;
  title?: string;
}

const NodeIcon = ({ name, title = '' }: NodeIconProps): React.ReactElement => (
  <Box component='img' src={nodeIcons[name]} alt={title} draggable={false} data-testid={`node-icon-${name}`} />
);

export default NodeIcon;
